module.exports = __webpack_public_path__ + "static/media/icona_wall.de68881c.svg";